const getParameterByName = (url, name) => {
  const escapedName = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + escapedName + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function headersFromGoogleUploadUrl(url) {
  const result = {}
  const signedHeadersStr = getParameterByName(url, 'X-Goog-SignedHeaders')
  if (signedHeadersStr) {
    const signedHeaders = signedHeadersStr.split(';')
    signedHeaders.forEach(header => {
      if ('host' != header) {
        result[header] = getParameterByName(url, header)
      }
    })
  }
  return result
}
